import { ColorValue, StyleProp, StyleSheet, ViewStyle } from 'react-native';
import { Button } from '../crop-circle/Button';

type AssetActionButtonProps = {
  onAddNew: () => void;
  buttonContainerStyle: StyleProp<ViewStyle>;
  buttonStyle: StyleProp<ViewStyle>;
  text: string;
  iconSize?: number;
  backgroundColor?: ColorValue | undefined;
  state?: 'default' | 'active' | 'warning' | 'outline';
};

export const AssetActionButton = (props: AssetActionButtonProps) => {
  return (
    <Button
      style={{
        ...styles.buttonContainer,
        ...(props.backgroundColor && {
          backgroundColor: props.backgroundColor,
        }),
      }}
      onPress={props.onAddNew}
      state={props.state}
    >
      {props.text}
    </Button>
  );
};

const styles = StyleSheet.create({
  buttonContainer: {
    flex: 1,
    height: 56,
    maxHeight: 56,
  },
});
